<template>
  <div id="modal-filter-medsos" class="form-modal">
    <div class="filter-pers m-b-10">
      <div class="row">
        <div class="col-md-6">
          <h6 class="fs-13" style="border-bottom: 1px solid #ccc">
            Berdasarkan Jenis Akun
          </h6>
          <div class="form-check complete">
            <input
              type="radio"
              name="showPers"
              v-model="filter_pers"
              id="persSemua"
              value="2"
              :checked="filter_pers == 2"
            />
            <label for="persSemua">Tampilkan Semua</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="showPers"
              v-model="filter_pers"
              id="pers"
              value="1"
              :checked="filter_pers == 1"
            />
            <label for="pers">Hanya Akun Pers</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="showPers"
              v-model="filter_pers"
              id="nonPers"
              value="0"
              :checked="filter_pers == 0"
            />
            <label for="nonPers">Hanya Akun Non Pers</label>
          </div>
        </div>
        <div class="col-md-6">
          <h6 class="fs-13" style="border-bottom: 1px solid #ccc">
            Berdasarkan Tanda
          </h6>
          <div class="form-check complete">
            <input
              type="radio"
              name="showTanda"
              v-model="filter_marked"
              :checked="filter_marked == 2"
              id="tandaSemua"
              value="2"
            />
            <label for="tandaSemua">Tampilkan Semua</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="showTanda"
              v-model="filter_marked"
              :checked="filter_marked == 1"
              id="tanda"
              value="1"
            />
            <label for="tanda"> Hanya akun yang ditandai</label>
          </div>
          <div class="form-check complete">
            <input
              type="radio"
              name="showTanda"
              v-model="filter_marked"
              :checked="filter_marked == 0"
              id="nonTanda"
              value="0"
            />
            <label for="nonTanda"> Hanya akun yang tidak ditandai</label>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-source m-b-20">
      <h6 class="fs-13" style="border-bottom: 1px solid #ccc">
        Filter Berdasarkan Source
      </h6>
      <div class="row">
        <div
          v-for="(source, index) in sources"
          :key="index"
          class="form-check complete col-md-4"
        >
          <input
            type="checkbox"
            :id="'check-' + index"
            v-model="filter_sources"
            :value="source.id"
          />
          <label :for="'check-' + index"> {{ source.name }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button @click="filter_data" class="btn btn-complete pull-right">
          Cari
        </button>
        <button class="btn btn-danger pull-right m-r-5" data-dismiss="modal">
          Batal
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
var sources = [
  { id: "Facebook", name: "Facebook" },
  { id: "Twitter", name: "Twitter" },
  { id: "Instagram", name: "Instagram" },
  { id: "Youtube", name: "Youtube" },
  { id: "Linkedin", name: "Linkedin" },
  { id: "Tiktok", name: "Tiktok" },
  { id: "Forum", name: "Forum" },
  { id: "Blog", name: "Blog" },
  { id: "Review", name: "Review Aplikasi" },
];
export default {
  name: "modal_filter_medsos",
  data() {
    return {
      sources: sources,
      filter_pers: this.$route.query.pers ? this.$route.query.pers : 2,
      filter_marked: this.$route.query.marked ? this.$route.query.marked : 2,
      filter_sources: [],
    };
  },
  methods: {
    filter_data: function () {
      let filter_sources_join = this.filter_sources.join(",").toLowerCase();
      let queries = JSON.parse(JSON.stringify(this.$route.query));

      queries["pers"] = this.filter_pers;
      queries["marked"] = this.filter_marked;
      queries["sources"] = btoa(filter_sources_join);
      this.$router.replace({ query: queries });
      $("#modalSlideUp").modal("hide");
    },
  },
  created: function () {
    if ("sources" in this.$route.query) {
      let param = atob(this.$route.query.sources).split(",");
      let self = this;
      param.forEach(function (item) {
        self.filter_sources.push(item.charAt(0).toUpperCase() + item.slice(1));
      });
    } else {
      let filter_active = [];
      sources.forEach(function (item) {
        filter_active.push(item.id.charAt(0).toUpperCase() + item.id.slice(1));
      });
      this.filter_sources = filter_active;
    }
  },
};
</script>